import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";
import EmergencyContactDisplay from "./emergencyContactDisplay";
import EditEmergencyContact from "./editEmergencyContact";
import useEmergencyContact from "./useEmergencyContact";
import { scrollIntoView } from "utils/helper";

function EmergencyContact({ isShowEditIcon = true }) {
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isEditMode, setIsEditMode] = useState(false);
  const { onEditSave, isLoading } = useEmergencyContact();

  const handleEditClick = () => {
    setIsEditMode(true);
  };

  const handleDiscard = () => {
    setIsEditMode(false);
    scrollIntoView("emergencyContactScrollId");
  };

  const handleSave = async (values) => {
    await onEditSave(values);
    setIsEditMode(false);
  };

  if (isEditMode) {
    return (
      <EditEmergencyContact
        onDiscard={handleDiscard}
        onSave={handleSave}
        isLoading={isLoading}
      />
    );
  }

  return (
    <EmergencyContactDisplay
      onEditClick={handleEditClick}
      isShowEditIcon={isShowEditIcon}
    />
  );
}

EmergencyContact.propTypes = {
  isShowEditIcon: PropTypes.bool,
};

export default EmergencyContact;